export const File = {
    kind: "File",
    fileURL: "/fbx/kuba.fbx",
};
